import React from 'react';
import {PrivacyScreen} from './screens';

function App() {
  return <PrivacyScreen />;
}

export default App;
